/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from 'react';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import useTranslation from 'hooks/useTranslation';
import {
  Container,
  Box,
  Hidden,
  Drawer,
  IconButton,
  ListItem,
  List,
  ListItemText,
  ListItemIcon,
  Divider,
  Typography,
  Grid,
  MenuItem,
  Collapse,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  StarBorderRounded as StarBorderRoundedIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess,
  ExpandMore,
  AppsRounded as AppsRoundedIcon,
} from '@material-ui/icons';

import Image from 'next/image';

import HeadsetIcon from 'assets/HeadsetIcon.svg';
import clsx from 'clsx';
// import { Follow, ModalBox } from "components";
import LogoPositiva from 'assets/logo/PrincipalPositivaPurple.svg';
import LogoNegativa from 'assets/logo/PrincipalNegativa.svg';
// Icons
import Instagram from '../../../public/images/instagramSm.svg';
import Facebook from '../../../public/images/facebook.svg';
import Names from '../../../public/images/names.svg';
import Dice from '../../../public/images/dice.svg';
import Numbers from '../../../public/images/numbers.svg';
import Roleta from '../../../public/images/wheel.svg';
import TikTok from '../../../public/images/tiktok.svg';
import Twitter from '../../../public/images/twitter.svg';
import Youtube from '../../../public/images/youtube.svg';
import parse from 'html-react-parser';

// import SelectLanguageMenu from "components/Common/SelectLanguageMenu";
// import Modal from "components/Common/Modal";
// import { HowDoesItWork } from "pages";
import { useHistory } from 'react-router-dom';
import theme from 'styles/theme';
import version from 'export/version.json';
import useStyles from './styles';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Follow } from 'components';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isOurAppsExtended, setIsOurAppsExtended] = useState<boolean>(false);
  const classes = useStyles();
  const router = useRouter();
  const toggleExpandOurAppsMobile = () => {
    setIsOurAppsExtended(!isOurAppsExtended);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClickApps = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseApps = () => {
    setAnchorEl(null);
  };

  const handlePage = (page: string) => {
    handleCloseApps();
    router.push(page);
  };

  return (
    <>
      <Box className={classes.headerStyles}>
        <Container className={classes.box}>
          <Box>
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => window.open('https://instasorteio.com', '_self')}
            >
              <Image
                className={classes.logo}
                src={LogoNegativa}
                alt="InstaSorteio"
                width={150}
                height={100}
              />
            </div>
          </Box>
          <Box className={classes.menu}>
            <Hidden smDown>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => window.open('https://instasorteio.com', '_self')}
              >
                <div className={classes.menuItem}>{t('home')}</div>
              </div>
              <Button
                className={`${classes.menuItem} ${classes.ourAppsWebBtn}`}
                onClick={handleClickApps}
              >
                {t('ourApps')}
                <ExpandMoreIcon />
              </Button>
              <Menu
                className={classes.menuDrop}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseApps}
              >
                <Grid container justify="space-between" spacing={7}>
                  <Grid item sm={6}>
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://instasorteio.com/instagram',
                          '_self',
                        )
                      }
                    >
                      <MenuItem
                        className={classes.gridMenuItem}
                        // onClick={() => handlePage("/sorteio/instagram")}
                      >
                        <ListItemIcon>
                          <div className={classes.imageBox}>
                            <Image src={Instagram} alt="instagram" width={22} />
                          </div>
                        </ListItemIcon>
                        {t('drawInstagram')}
                      </MenuItem>
                    </div>

                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://instasorteio.com/sorteio-de-nomes',
                          '_self',
                        )
                      }
                    >
                      <MenuItem
                        className={classes.gridMenuItem}
                        // onClick={() => handlePage("/sorteio-de-nomes")}
                      >
                        <ListItemIcon
                          style={{ color: theme.palette.error.main }}
                        >
                          <div className={classes.imageBox}>
                            <Image width={22} src={Names} alt="Random Name" />
                          </div>
                        </ListItemIcon>
                        {t('drawNames')}
                      </MenuItem>
                    </div>

                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://instasorteio.com/sorteio-de-dados',
                          '_self',
                        )
                      }
                    >
                      <MenuItem
                        className={classes.gridMenuItem}
                        // onClick={() => handlePage("/sorteio-de-dados")}
                      >
                        <ListItemIcon>
                          <div className={classes.imageBox}>
                            <Image width={22} src={Dice} alt="Random Dice" />
                          </div>
                        </ListItemIcon>
                        {t('drawDice')}
                      </MenuItem>
                    </div>

                    {/* <Link href="/sorteio-no-twitter" passHref> */}
                    {/*  <MenuItem
                      className={classes.gridMenuItem}
                      style={{
                        opacity: 0.5,
                        cursor: 'not-allowed',
                      }}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={22} src={Twitter} alt="Twitter" />
                        </div>
                      </ListItemIcon>
                      {t('drawTwitter')}
                    </MenuItem> */}
                    {/* </Link> */}

                    {/* <Link href="/sorteio-no-youtube" passHref> */}
                    {/*  <MenuItem
                      className={classes.gridMenuItem}
                      style={{
                        opacity: 0.5,
                        cursor: 'not-allowed',
                      }}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={22} src={Youtube} alt="Youtube" />
                        </div>
                      </ListItemIcon>
                      {t('drawYoutube')}
                    </MenuItem> */}
                    {/* </Link> */}
                  </Grid>

                  <Grid item sm={6}>
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://instasorteio.com/sorteio-de-numeros',
                          '_self',
                        )
                      }
                    >
                      <MenuItem
                        className={classes.gridMenuItem}
                        // onClick={() => handlePage("sorteio-de-numeros")}
                        // href="https://dev.instasorteio.como/sorteio-de-numeros"
                      >
                        <ListItemIcon>
                          <div className={classes.imageBox}>
                            <Image width={22} src={Numbers} alt="numbers" />
                          </div>
                        </ListItemIcon>
                        {t('drawNumbers')}
                      </MenuItem>
                    </div>

                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          'https://instasorteio.com/sorteio-de-roleta',
                          '_self',
                        )
                      }
                    >
                      <MenuItem
                        className={classes.gridMenuItem}
                        // onClick={() => handlePage("/sorteio-de-roleta")}
                      >
                        <ListItemIcon>
                          <div className={classes.imageBox}>
                            <Image width={22} src={Roleta} alt="Random Wheel" />
                          </div>
                        </ListItemIcon>
                        {t('drawRoulette')}
                      </MenuItem>
                    </div>

                    {/*   <MenuItem
                      className={classes.gridMenuItem}
                      style={{
                        opacity: 0.5,
                        cursor: 'not-allowed',
                      }}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={22} src={TikTok} alt="TikTok" />
                        </div>
                      </ListItemIcon>
                      {t('drawYoutube')}
                    </MenuItem> */}
                    {/* </Link> */}
                  </Grid>
                </Grid>
              </Menu>
              <Link href="/como-funciona" passHref>
                <div className={classes.menuItem}>{t('howItWorks')}</div>
              </Link>

              <Follow />
            </Hidden>
            <Hidden mdUp>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                className={clsx(open && classes.hide)}
              >
                <MenuIcon color="secondary" />
              </IconButton>
            </Hidden>
          </Box>
        </Container>
      </Box>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Box className={classes.ajustLayoutDrawerMenu}>
          <Box className={classes.closeDrawer}>
            <Image
              width={100}
              height={100}
              className={classes.logo}
              src={LogoPositiva}
              alt="InstaSorteio"
            />
            <IconButton
              onClick={handleDrawerClose}
              className={classes.closeDrawerButton}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={classes.menuDrawer}>
            <List>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => window.open('https://instasorteio.com', '_self')}
              >
                <ListItem
                  className={classes.menuItemDrawer}
                  style={{ cursor: 'pointer' }}
                >
                  <ListItemIcon>
                    <StarBorderRoundedIcon className={classes.icons} />
                  </ListItemIcon>
                  <ListItemText>{t('home')}</ListItemText>
                </ListItem>
              </div>

              <Divider />

              <ListItem
                className={classes.menuItemDrawer}
                onClick={toggleExpandOurAppsMobile}
                button
              >
                <ListItemIcon>
                  <AppsRoundedIcon className={classes.icons} />
                </ListItemIcon>
                <ListItemText>{t('ourApps')}</ListItemText>
                {isOurAppsExtended ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Divider />
              <Collapse in={isOurAppsExtended} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        'https://instasorteio.com' +
                          `/${router.locale}/sorteio/instagram`,
                        '_self',
                      )
                    }
                  >
                    <MenuItem
                      className={classes.gridMenuItem}
                      // onClick={() => handlePage("/")}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={16} src={Instagram} alt="instagram" />
                        </div>
                      </ListItemIcon>
                      <ListItemText>{t('drawInstagram')}</ListItemText>
                    </MenuItem>
                  </div>

                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        'https://instasorteio.com/sorteio-de-nomes',
                        '_self',
                      )
                    }
                  >
                    <MenuItem
                      className={classes.gridMenuItem}
                      // onClick={() => handlePage("insertnames")}
                    >
                      <ListItemIcon style={{ color: theme.palette.error.main }}>
                        <div className={classes.imageBox}>
                          <Image width={16} src={Names} alt="Random Names" />
                        </div>
                      </ListItemIcon>
                      <ListItemText>{t('drawNames')}</ListItemText>
                    </MenuItem>
                  </div>

                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        'https://instasorteio.com/sorteio-de-dados',
                        '_self',
                      )
                    }
                  >
                    <MenuItem
                      className={classes.gridMenuItem}
                      // onClick={() => handlePage("dice")}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={16} src={Dice} alt="Random Die" />
                        </div>
                      </ListItemIcon>
                      <ListItemText>{t('drawDice')}</ListItemText>
                    </MenuItem>
                  </div>

                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        'https://instasorteio.com/sorteio-de-numeros',
                        '_self',
                      )
                    }
                  >
                    <MenuItem
                      className={classes.gridMenuItem}
                      // onClick={() => handlePage("numbers")}
                    >
                      <ListItemIcon>
                        <div className={classes.imageBox}>
                          <Image width={16} src={Numbers} alt="numbers" />
                        </div>
                      </ListItemIcon>
                      <ListItemText>{t('drawNumbers')}</ListItemText>
                    </MenuItem>
                  </div>

                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      window.open(
                        'https://instasorteio.com/sorteio-de-roleta',
                        '_self',
                      )
                    }
                  >
                    <MenuItem
                      className={classes.gridMenuItem}
                      // onClick={() => handlePage("roulette")}
                    >
                      <ListItemIcon
                        style={{ color: theme.palette.warning.main }}
                      >
                        <div className={classes.imageBox}>
                          <Image width={16} src={Roleta} alt="Wheel" />
                        </div>
                      </ListItemIcon>
                      <ListItemText>{t('drawRoulette')}</ListItemText>
                    </MenuItem>
                  </div>

                  {/* <MenuItem
                    className={classes.gridMenuItem}
                    style={{
                      opacity: 0.5,
                      cursor: "not-allowed",
                    }}
                  >
                    <ListItemIcon>
                      <div className={classes.imageBox}>
                        <Image width={16} src={Youtube} alt="YouTube" />
                      </div>
                    </ListItemIcon>
                    <ListItemText>{t("drawYoutube")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className={classes.gridMenuItem}
                    style={{
                      opacity: 0.5,
                      cursor: "not-allowed",
                    }}
                  >
                    <ListItemIcon>
                      <div className={classes.imageBox}>
                        <Image width={16} src={Twitter} alt="Twitter" />
                      </div>
                    </ListItemIcon>
                    <ListItemText>{t("drawTwitter")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className={classes.gridMenuItem}
                    style={{
                      opacity: 0.5,
                      cursor: "not-allowed",
                    }}
                  >
                    <ListItemIcon>
                      <div className={classes.imageBox}>
                        <Image width={16} src={TikTok} alt="TikTok" />
                      </div>
                    </ListItemIcon>
                    <ListItemText>{t("drawTikTok")}</ListItemText>
                  </MenuItem> */}
                  {/* </Link> */}
                </List>
              </Collapse>

              <ListItem
                className={classes.menuItemDrawer}
                onClick={() => handlePage('/como-funciona')}
                // href="https://dev.instasorteio.como/como-funciona"
                style={{ cursor: 'pointer' }}
              >
                <ListItemIcon>
                  <span
                    className={classes.icons}
                    style={{
                      width: 23,
                      height: 23,
                      fontSize: 16,
                      fontWeight: 600,
                    }}
                  >
                    ?
                  </span>
                </ListItemIcon>
                <ListItemText>{t('howItWorks')}</ListItemText>
              </ListItem>
              <Divider />

              <Link href="mailto:contato@instasorteio.com" passHref>
                <ListItem
                  className={classes.menuItemDrawer}
                  component="a"
                  target="_blank"
                >
                  <ListItemIcon>
                    <Image width={25} src={HeadsetIcon} alt="none" />
                  </ListItemIcon>
                  <ListItemText>{t('contactUs')}</ListItemText>
                </ListItem>
              </Link>

              <Divider />
            </List>
          </Box>

          <Box className={classes.followDrawer}>{/* <Follow /> */}</Box>
          <Box
            style={{
              fontSize: 12,
              color: theme.palette.grey[300],
              textAlign: 'right',
            }}
          >
            versão: {version.version}
          </Box>
          <div className={classes.languageMenu}>
            {/* <SelectLanguageMenu /> */}
          </div>
          <Typography variant="body2" className={classes.copyright}>
            {t('copyright')}
          </Typography>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
